<template>
  <div>
    <Loader v-if="performingRequest &&  (!this.eventShiftsDays || this.eventShiftsDays.length == 0)" />

    <div class="dashboard__container--header" v-if="eventInfo && eventInfo.id && (eventInfo.shiftType && (eventInfo.shiftType != 'Permanent' && eventInfo.shiftType != 'Job'))">
      <div class="text-right mb-3" style="width:100%;">
              
        <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isVisible, 'btn__outlined': !isVisible }" @click="showVisible()">Visible</button>
        <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPaid, 'btn__outlined': !isPaid }" @click="showPaid()">Paid</button>
        <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isHidden, 'btn__outlined': !isHidden }" @click="showHidden()">Hidden</button>

        <!-- <button class="btn btn__small btn__outlined mr-3 mb-3" @click.prevent="exportRegister()">Billing Export<i class="fas fa-external-link ml-3"></i></button> -->

      </div>
    </div>


    <div class="dashboard__container pb-0 pt-3" v-if="eventInfo && eventInfo.id && (eventInfo.shiftType && (eventInfo.shiftType == 'Permanent' || eventInfo.shiftType == 'Job'))">
      <div class="flex flex-wrap justify-space-between mb-3" style="width:100%;">
        <span>
          <button v-if="!isShowDateFilter" class="btn btn__small mr-3" v-bind:class="{ 'btn__primary': (assignmentsByDate && assignmentsByDate.length >= 1), 'btn__outlined': (!assignmentsByDate || assignmentsByDate.length == 0) }" @click="showDateFilter()">Date Filter <i class="fa-regular fa-sliders ml-2"></i></button>
          <button v-if="isShowDateFilter" class="btn btn__small mr-3" v-bind:class="{ 'btn__primary': (assignmentsByDate && assignmentsByDate.length >= 1), 'btn__dark': (!assignmentsByDate || assignmentsByDate.length == 0) }" @click="hideDateFilter()">Hide Date Filter <i class="fa-regular fa-sliders ml-2"></i></button>

          <button v-if="!isShowShiftFilter" class="btn btn__small mr-3" v-bind:class="{ 'btn__primary': (assignmentsByShift && assignmentsByShift.length >= 1), 'btn__outlined': (!assignmentsByShift || assignmentsByShift.length == 0) }" @click="showShiftFilter()">Shift Filter <i class="fa-regular fa-sliders ml-2"></i></button>
          <button v-if="isShowShiftFilter" class="btn btn__small mr-3" v-bind:class="{ 'btn__primary': (assignmentsByShift && assignmentsByShift.length >= 1), 'btn__dark': (!assignmentsByShift || assignmentsByShift.length == 0) }" @click="hideShiftFilter()">Hide Shift Filter <i class="fa-regular fa-sliders ml-2"></i></button>

          <button v-if="!isShowUserFilter" class="btn btn__small mr-3" v-bind:class="{ 'btn__primary': (assignmentsByUser && assignmentsByUser.length >= 1), 'btn__outlined': (!assignmentsByUser || assignmentsByUser.length == 0) }" @click="showUserFilter()">User Filter <i class="fa-regular fa-sliders ml-2"></i></button>
          <button v-if="isShowUserFilter" class="btn btn__small mr-3" v-bind:class="{ 'btn__primary': (assignmentsByUser && assignmentsByUser.length >= 1), 'btn__dark': (!assignmentsByUser || assignmentsByUser.length == 0) }" @click="hideUserFilter()">Hide User Filter <i class="fa-regular fa-sliders ml-2"></i></button>

          <button v-if="!isShowAddRows" class="btn btn__small btn__outlined mr-3" @click="showAddRows()">Add Rows <i class="fa-regular fa-plus ml-2"></i></button>
          <button v-if="isShowAddRows" class="btn btn__small btn__dark mr-3" @click="hideAddRows()">Hide Adding Rows <i class="fa-regular fa-plus ml-2"></i></button>

        </span>
        <span>
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isVisible, 'btn__outlined': !isVisible }" @click="showVisiblePerm()">Visible</button>
          <!-- <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPaid, 'btn__outlined': !isPaid }" @click="showPaid()">Paid</button> -->
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isHidden, 'btn__outlined': !isHidden }" @click="showHiddenPerm()">Hidden</button>

          <!-- <button class="btn btn__small btn__outlined mr-3 mb-3" @click.prevent="exportRegister()">Billing Export<i class="fas fa-external-link ml-3"></i></button> -->
        </span>

      </div>
    </div>

    <transition name="fadeStop">
      <div class="dashboard__container pb-0 pt-0" v-if="isShowUserFilter">
        <h4>Filter User:</h4>
        <div class="flex flex-row flex-wrap mt-3 mb-5">
          <div class="whiteBack" style="width:20%; min-width: 28rem;">
            <v-select
               label="lastName"
              :options="uniqueGroupUsers"
              clearable
              v-model="filteredUser"
              
              >
        <!--       <template #label="option">
                {{option.firstName}} {{option.lastName}}
              </template> -->
              <template #option="option">
                {{option.firstName}} {{option.lastName}}
              </template>
              <!-- @input="filterShift()" -->
            </v-select>
          </div>
          <div class="ml-5 mb-3" v-if="filteredUser">
            <button class="btn btn__dark btn__small" @click="clearUser()">Clear User</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fadeStop">
      <div class="dashboard__container pb-0 pt-0" v-if="isShowShiftFilter">
        <h4>Filter Shifts:</h4>
        <div class="flex flex-row flex-wrap mt-3 mb-5">
          <div class="whiteBack" style="width:20%; min-width: 28rem;">
            <v-select
              label="title" 
              :options="eventShifts"
              clearable
              v-model="filteredShift"
              
              >
             <!--  <template #option="option">
                Monday: {{option.mondayStart}} - {{option.mondayEnd}} | {{option.event}}
              </template>
              <template #option="option" v-if="option.title">
                {{option.title}}
              </template> -->
              <!-- @input="filterShift()" -->
            </v-select>
          </div>
          <div class="ml-5 mb-3" v-if="filteredShift">
            <button class="btn btn__dark btn__small" @click="clearShift()">Clear Shift</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fadeStop">
      <div class="dashboard__container pb-0 pt-0" v-if="isShowDateFilter">
        <h4>Filter Dates:</h4>
        <div class="flex flex-row flex-wrap mt-3 mb-5">
          <div class="whiteBack">
            <label for="start">Start Date</label>
            <input type="date" v-model="startDate" />
          </div>
          <div class="whiteBack ml-5">
            <label for="end">End Date</label>
            <input type="date" v-model="endDate" />
          </div>
          <div class="ml-5 mb-3" v-if="endDate && startDate">
            <button class="btn btn__dark btn__small" @click="clearDates()">Clear Dates</button>
          </div>
          
        </div>
      </div>
    </transition>

    <transition name="fadeStop">
      <div class="dashboard__container pb-0 pt-0" v-if="isShowAddRows">
        <h4>Add Rows:</h4>
        <div class="flex flex-row flex-wrap">
          <div class="flex mt-3">
            <button class="chipDark mr-2 mb-2" v-for="(item, index) in shiftDates" @click="removeDay(index)">{{item}} <i class="fa-regular fa-xmark"></i></button>
          </div>
        </div>
        <div class="flex flex-row flex-wrap">
          <div class="whiteBack mb-5" style="width:20%; min-width: 12rem;">
            <div class="mb-3">
              <label for="pickDate">Select Dates:</label>
              <input type="date" v-model="newShiftDate" id="pickDate" @input="onPickDate()" />
            </div>
          </div>
          <!-- <div class="whiteBack mb-5" style="width:20%; min-width: 12rem;">
            <div class="mb-3">
              <label for="row">Date:</label>
              <input type="date" v-model="newRow.date" />
            </div>
          </div> -->
          <div class="whiteBack mb-5 ml-3" style="width:20%; min-width: 18rem;">
            <div class="mb-3" v-if="(uniqueGroupUsers && uniqueGroupUsers.length >= 1)">
              <label for="row">Worker:</label>
              <v-select
                label="lastName" 
                :options="uniqueGroupUsers"
                clearable
                v-model="newRow.user"
                >
                <template #option="option">
                  {{option.firstName}} {{option.lastName}} {{option.userId}}
                </template>
              </v-select>
            </div>
          </div>
          <div class="whiteBack mb-5 ml-3" style="width:20%; min-width: 18rem;">
            <div class="mb-3" v-if="(permShifts && permShifts.length >= 1)">
              <label for="row">Shift:</label>
              <v-select
                label="event" 
                :options="permShifts"
                clearable
                v-model="newRow.shift"
                >
                <template #option="option">
                  Monday: {{option.mondayStart}} - {{option.mondayEnd}} | {{option.event}}
                </template>
              </v-select>
            </div>
          </div>
          <div class="mb-5 ml-3" v-if="newRow.shift && newRow.user && shiftDates && shiftDates.length >= 1">
            <button class="btn btn__primary btn__small" @click="addRow()">Add Rows</button>
          </div>
        </div>
      </div>
    </transition>

    <div class="dashboard__container pt-3" v-if="eventInfo && eventInfo.id && (eventInfo.shiftType && (eventInfo.shiftType == 'Permanent' || eventInfo.shiftType == 'Job'))">
      
      <div class="dashboard__container--body">

        <PayrollTable v-if="(allVisible && allVisible.length >= 1) && (!filteredAssignments || filteredAssignments.length == 0) && !isHidden" :eventAssignments="allVisible" />

        <PayrollTable v-if="(filteredAssignments && filteredAssignments.length >= 1) && !isHidden" :eventAssignments="filteredAssignments" />

        <PayrollTableAlt v-if="isHidden && allHidden && allHidden.length >= 1" :eventInfo="eventInfo" :eventAssignments="allHidden" :hidden="true" />

      </div>

    </div>
    <div class="dashboard__container pt-3" v-if="eventInfo && eventInfo.id && (!eventInfo.shiftType || (eventInfo.shiftType != 'Permanent' && eventInfo.shiftType != 'Job'))">
      <div class="whiteBack mb-3" style="width:50%; min-width: 20rem;">
        <label for="pickDay" class="mb-2" v-if="!showAll">Choose Day:</label>
        <v-select
          v-if="!showAll"
          label="title" 
          :options="eventShiftsDays"
          clearable
          v-model="activeDay"
          @input="updateDay()"
          >
        </v-select>
        <button class="btn btn__outlined btn__small mt-4" @click="showAllSheets()" v-if="!showAll">Show All</button>
        <button class="btn btn__outlined btn__small mt-4" @click="hideAllSheets()" v-if="showAll">Hide All</button>
      </div>

      <div class="dashboard__container--body"  v-if="showAll">

        <div class="text-right mb-3" style="width:100%;">
              
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isVisible, 'btn__outlined': !isVisible }" @click="showVisible()">Visible</button>
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPaid, 'btn__outlined': !isPaid }" @click="showPaid()">Paid</button>
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isHidden, 'btn__outlined': !isHidden }" @click="showHidden()">Hidden</button>

          <!-- <button class="btn btn__small btn__outlined mr-3 mb-3" @click.prevent="exportRegister()">Billing Export<i class="fas fa-external-link ml-3"></i></button> -->

        </div>  
        <PayrollTable v-if="isVisible" :eventInfo="eventInfo" :eventAssignments="visibleAssignments" />

        <PayrollTableAlt v-if="isHidden" :eventInfo="eventInfo" :eventAssignments="hiddenAssignments" :hidden="true" />

        <PayrollTable v-if="isPaid" :eventInfo="eventInfo" :eventAssignments="paidAssignments" :hidden="false" />

      </div>

      <div class="dashboard__container--body"  v-if="activeDay && !showAll">

        <div class="text-right mb-3" style="width:100%;">
              
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isVisibleByDay, 'btn__outlined': !isVisibleByDay }" @click="showVisibleByDay()">Visible</button>
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isPaidByDay, 'btn__outlined': !isPaidByDay }" @click="showPaidByDay()">Paid</button>
          <button class="btn btn__small mr-3" v-bind:class="{ 'btn__dark': isHiddenByDay, 'btn__outlined': !isHiddenByDay }" @click="showHiddenByDay()">Hidden</button>
          <!-- <button class="btn btn__small btn__outlined mr-3 mb-3" @click.prevent="exportRegisterByDay()">Day Billing Export<i class="fas fa-external-link ml-3"></i></button> -->
        </div>

        <PayrollTable v-if="isVisibleByDay" :eventInfo="eventInfo" :eventAssignments="visibleAssignmentsByDay" />

        <PayrollTableAlt :hidden="true" v-if="isHiddenByDay" :eventInfo="eventInfo" :eventAssignments="hiddenAssignmentsByDay" />

        <PayrollTable :hidden="false" v-if="isPaidByDay" :eventInfo="eventInfo" :eventAssignments="paidAssignmentsByDay" />

      </div>
    </div>
  </div>
</template>

<style scoped>
  .vgt-selection-info-row {
    height: 3.28rem;
  }
</style>

<script>
import { mapState } from 'vuex'
import Loader from '@/components/Loader.vue'
// import ExportService from "@/services/ExportService"
// import TimesheetNote from '@/components/Timesheets/TimesheetNote.vue'
import PayrollTable from '@/components/PayrollTable.vue'
import PayrollTableAlt from '@/components/PayrollTableAlt.vue'
import firebase from 'firebase/app';
import * as moment from 'moment'
const fb = require('../../firebaseConfig.js')

export default {
  props: ['eventInfo', 'eventShifts', 'eventShiftsDays'],
  name: 'eventTimesheets',
  data: () => ({
    newShiftDate: "",
    shiftDates: [],
    isShowAddRows: false,
    isShowDateFilter: false,
    isShowShiftFilter: false,
    isShowUserFilter: false,
    performingRequest: false,
    showAll: false,
    isVisible: true,
    isHidden: false,
    isPaid: false,
    isVisibleByDay: true,
    isHiddenByDay: false,
    isPaidByDay: false,
    activeItem: null,
    activeDay: '',
    endDate: null,
    startDate: null,
    filteredShift: null,
    filteredUser: null,
    newRow: {
      // date: null,
      user: null,
      shift: null
    },
  }),
  created () {
    if (!this.eventAssignments || this.eventAssignments.length < 1) {
      this.$store.dispatch("getEventAssignments", this.$route.params.id)
    }
    if (!this.eventGroupUsers || this.eventGroupUsers.length < 1) {
      this.$store.dispatch("getEventGroupUsers", this.$route.params.id)
    }
    // if (!this.eventShifts || this.eventShifts.length < 1) {
    //   this.$store.dispatch("getEventShifts", this.$route.params.id)
    // }
    // if (!this.eventShiftsDays || this.eventShiftsDays.length < 1) {
    //   this.$store.dispatch("getEventShiftsDays", this.$route.params.id)
    // }
  },
  // mounted() {
  //   this.$store.dispatch("getEventAssignments", this.$route.params.id)
  //   // if (this.eventInfo && this.eventInfo.id) {
  //   //   this.$store.dispatch("getEventGroupUsers", {
  //   //     event: this.eventInfo
  //   //   })
  //   // }
  // },
  computed: {
    ...mapState(['eventAssignments', 'eventAssignmentsByDay', 'currentUser', 'eventGroupUsers']),
    uniqueGroupUsers() {
      // return Array.from(new Set(this.eventGroupUsers));


      const uniqueGroup = this.eventGroupUsers.filter((value, index, self) =>
        index === self.findIndex((t) => (
          t.userId === value.userId
        ))
      )

      let uniqueArray = [...new Set(uniqueGroup)];

      // const filteredUnique = uniqueGroup.filter(item => {
      //   return !item.hidden
      // })
      return uniqueArray

      // return this.eventGroupUsers.filter((item,
      //   index) => this.eventGroupUsers.indexOf(item) === index);
      // // let uniqueArray = [...new Set(this.eventGroupUsers)];
      // // let uniqueArray = []
      // // this.eventGroupUsers.forEach(item => {
      // //   if (!uniqueArray.includes(item)) {
      // //     uniqueArray.push(item);
      // //   }
      // // })
      // return uniqueArray
    },
    permShifts() {
      return this.eventShifts.filter(shift => {
        return (shift.type == 'Permanent' || shift.type == 'Job')
      })
    },
    allVisible() {
      if (this.eventInfo && this.eventInfo.shiftType && (this.eventInfo.shiftType == 'Permanent' || this.eventInfo.shiftType == 'Job')) {
        return this.eventAssignments.filter(item => {
          return (!item.hidden || item.hidden != true)
        })
      }
    },
    allHidden() {
      if (this.eventInfo && this.eventInfo.shiftType && (this.eventInfo.shiftType == 'Permanent' || this.eventInfo.shiftType == 'Job')) {
        return this.eventAssignments.filter(item => {
          return (item.hidden)
        })
      }
    },
    visibleAssignments() {
      if (this.showAll) {
        return this.eventAssignments.filter(item => {
          return ((!item.hidden || item.hidden != true) && (!item.paystatus || item.paystatus != 'paid'))
        })
      }
    },
    hiddenAssignments() {
      if (this.showAll) {
        return this.eventAssignments.filter(item => {
          return (item.hidden)
        })
      }
    },
    paidAssignments() {
      if (this.showAll) {
        return this.eventAssignments.filter(item => {
          return (item.paystatus === 'paid')
        })
      }
    },
    visibleAssignmentsByDay() {
      if (this.isVisibleByDay && this.activeDay && !this.showAll) {
        return this.eventAssignmentsByDay.filter(item => {
          return ((!item.hidden || item.hidden != true) && (!item.paystatus || item.paystatus != 'paid') && item.day == this.activeDay)
        })
      } else {}
    },
    hiddenAssignmentsByDay() {
      if (this.isHiddenByDay && this.activeDay && !this.showAll) {
        return this.eventAssignmentsByDay.filter(item => {
          return (item.hidden && item.day == this.activeDay)
        })
      } else {}
    },
    paidAssignmentsByDay() {
      if (this.isPaidByDay && this.activeDay && !this.showAll) {
        return this.eventAssignmentsByDay.filter(item => {
          return (item.paystatus == 'paid' && item.day == this.activeDay)
        })
      } else {}
    },
    assignmentsByDate() {
      if (this.startDate && this.endDate) {
        let startDate = new Date(this.startDate);
        let endDate = new Date(this.endDate);
      
        return this.allVisible.filter(item => {
          let eventDate = new Date(item.date)
          return ((eventDate >= startDate) && (eventDate <= endDate)) 
        })
      }
    },
    assignmentsByShift() {
      if (this.filteredShift) {
        return this.allVisible.filter(item => {
          return item.shiftId == this.filteredShift.id
        })
      }
    },
    assignmentsByUser() {
      if (this.filteredUser) {
        return this.allVisible.filter(item => {
          return item.userId == this.filteredUser.userId
        })
      }
    },
    filteredAssignments() {
      if (this.assignmentsByUser || this.assignmentsByShift || this.assignmentsByDate) {
        let usersArray = this.assignmentsByUser || []
        let shiftsArray = this.assignmentsByShift || []
        let datesArray = this.assignmentsByDate || []
        // let newArray = [...usersArray, ...shiftsArray, ...datesArray];
        // const newArray = this.assignmentsByUser.concat(this.assignmentsByShift, this.assignmentsByDate);
        // return newArray
        let shiftUserArray
        let shiftUserDateArray

        if ((usersArray && usersArray.length >= 1) && (shiftsArray && shiftsArray.length >= 1)) {
          shiftUserArray = usersArray.filter(element => shiftsArray.includes(element));
        } else if ((usersArray && usersArray.length >= 1) && (!shiftsArray || shiftsArray.length == 0)) {
          shiftUserArray = usersArray
        } else if ((!usersArray || usersArray.length == 0) && (shiftsArray && shiftsArray.length >= 1)) {
          shiftUserArray = shiftsArray
        } else {
          shiftUserArray = []
        }

        if ((shiftUserArray && shiftUserArray.length >= 1) && (datesArray && datesArray.length >= 1)) {
          shiftUserDateArray = shiftUserArray.filter(element => datesArray.includes(element));
        } else if ((shiftUserArray && shiftUserArray.length >= 1) && (!datesArray || datesArray.length == 0)) {
          shiftUserDateArray = shiftUserArray
        } else if ((!shiftUserArray || shiftUserArray.length == 0) && (datesArray && datesArray.length >= 1)){
          shiftUserDateArray = datesArray
        } else {
          shiftUserDateArray = []
        }
        return shiftUserDateArray
      }
    }
  },
  components: {
    Loader,
    PayrollTable,
    PayrollTableAlt
  },
  // async mounted() {
  //   if (this.eventShiftsDays && this.eventShiftsDays.length >= 1) {
  //     this.setStartDay()
  //   }
  // },
  methods: {
    removeDay(index) {
      this.shiftDates.splice(index, 1);
    },
    onPickDate() {
      this.shiftDates.push(this.newShiftDate)
      this.newShiftDate = ''
    },
    async addRow() {
      console.log(this.newRow.user)
      await this.shiftDates.forEach(date => {
        this.performingRequest = true
        var lockJob = firebase.functions().httpsCallable('lockJob');
        let fullName = this.newRow.user.firstName + ' ' + this.newRow.user.lastName
        let user = this.newRow.user
        // user.userId = this.newRow.user.id
        user.realId = this.newRow.user.id
        user.fullName = fullName
        lockJob({
          event: this.eventInfo,
          day: date,
          row: user,
          shift: this.newRow.shift,
        })
        .then((result) => {
          console.log(result)
          this.newRow = {}
          this.newShiftDate = null,
          this.shiftDates = [],
          this.performingRequest = false
        })
      })
    },
    async showAllSheets() {
      this.showAll = true
      await this.$store.dispatch("getEventAssignments", this.$route.params.id)
    },
    async hideAllSheets() {
      this.showAll = false
      await this.$store.dispatch("clearEventAssignments")
    },
    updateDay() {
      this.performingRequest = true
      this.$store.dispatch('clearEventAssignments')
      this.$store.dispatch("clearEventAssignmentsByDay")
      if (this.activeDay) {
        this.$store.dispatch("getEventAssignmentsByDay", {
          eventId: this.eventInfo.id,
          day: this.activeDay
        })
      } else {
        this.$store.dispatch('clearEventAssignmentsByDay')
      }
    },
    showUserFilter() {
      this.isShowUserFilter = true
      this.isShowDateFilter = false
      this.isShowShiftFilter = false
      this.isShowAddRows = false
      this.isHidden = false
      this.isVisible = true
    },
    hideUserFilter() {
      this.isShowUserFilter = false
    },
    clearUser() {
      this.filteredUser = null
    },
    showShiftFilter() {
      this.isShowShiftFilter = true
      this.isShowDateFilter = false
      this.isShowUserFilter = false
      this.isShowAddRows = false
      this.isHidden = false
      this.isVisible = true
    },
    hideShiftFilter() {
      this.isShowShiftFilter = false
    },
    clearShift() {
      this.filteredShift = null
    },
    showDateFilter() {
      this.isShowDateFilter = true
      this.isShowShiftFilter = false
      this.isShowUserFilter = false
      this.isShowAddRows = false
      this.isHidden = false
      this.isVisible = true
    },
    hideDateFilter() {
      this.isShowDateFilter = false
    },
    clearDates() {
      this.startDate = null
      this.endDate = null
    },
    showAddRows() {
      this.isShowAddRows = true
      this.isShowDateFilter = false
      this.isShowShiftFilter = false
      this.isHidden = false
      this.isVisible = true
    },
    hideAddRows() {
      this.isShowAddRows = false
    },
    showHiddenPerm() {
      this.isShowDateFilter = false
      this.isShowAddRows = false
      this.isHidden = true
      this.isVisible = false
      this.isPaid = false
      this.isPaidByDay = false
      this.isVisibleByDay = false
      this.isHiddenByDay = false
    },
    showHidden() {
      this.isShowDateFilter = false
      this.isShowAddRows = false
      this.isHidden = true
      this.isVisible = false
      this.isPaid = false
      this.isPaidByDay = false
      this.isVisibleByDay = false
      this.isHiddenByDay = false
    },
    showVisiblePerm() {
      this.isVisible = true
      this.isHidden = false
      this.isPaid = false
      this.isPaidByDay = false
      this.isVisibleByDay = false
      this.isHiddenByDay = false
    },
    showVisible() {
      this.isVisible = true
      this.isHidden = false
      this.isPaid = false
      this.isPaidByDay = false
      this.isVisibleByDay = false
      this.isHiddenByDay = false
    },
    showPaid() {
      this.isPaid = true
      this.isVisible = false
      this.isHidden = false
      this.isPaidByDay = false
      this.isVisibleByDay = false
      this.isHiddenByDay = false
    },
    showHiddenByDay() {
      if (this.activeDay) {
        this.isHiddenByDay = true
        this.isVisibleByDay = false
        this.isPaidByDay = false
        this.isHidden = false
        this.isVisible = false
        this.isPaid = false
      }
    },
    showVisibleByDay() {
      if (this.activeDay) {
        this.isVisibleByDay = true
        this.isHiddenByDay = false
        this.isPaidByDay = false
        this.isHidden = false
        this.isVisible = false
        this.isPaid = false
      }
    },
    showPaidByDay() {
      if (this.activeDay) {
        this.isPaidByDay = true
        this.isVisibleByDay = false
        this.isHiddenByDay = false
        this.isHidden = false
        this.isVisible = false
        this.isPaid = false
      }
    },
    // formatDate(q) {
    //   if(q) {
    //     const postedDate = new Date(q.seconds) * 1000;

    //     return moment.utc(postedDate).local().format('HH:mm:ss A')
    //   } else {
    //     return null
    //   }
    // },
    // exportRegisterByDay() {
    //   this.performingRequest = true
    //   const exportHeaders = [
    //     "Date",
    //     "First Name",
    //     "Last Name",
    //     "Position",
    //     "Hourly Rate",
    //     "Clock-In",
    //     "Clock-Out",
    //     "Total Hours",
    //     "Break",
    //     "Reg Hours",
    //     "Billable Hours",
    //     "Overtime",
    //     "2x Overtime",
    //     "Break Penalty",
    //     "CC Tips"
    //   ];
    //   const exportItems = [];
    //   for (var key in this.eventAssignmentsByDay) {

    //     if (!this.eventAssignmentsByDay[key].hidden) {

    //       let billHours
    //       if (this.eventAssignmentsByDay[key].minHours > this.eventAssignmentsByDay[key].regHours) {
    //         billHours = this.eventAssignmentsByDay[key].minHours
    //       } else {
    //         billHours = this.eventAssignmentsByDay[key].regHours
    //       } 

    //       exportItems.push([
    //         this.eventAssignmentsByDay[key].date,
    //         this.eventAssignmentsByDay[key].firstName,
    //         this.eventAssignmentsByDay[key].lastName,
    //         this.eventAssignmentsByDay[key].position,
    //         this.eventAssignmentsByDay[key].regRate,
    //         this.eventAssignmentsByDay[key].inTime,
    //         this.eventAssignmentsByDay[key].outTime,
    //         this.eventAssignmentsByDay[key].totalHours,
    //         this.eventAssignmentsByDay[key].breakTime,
    //         this.eventAssignmentsByDay[key].regHours,
    //         billHours,
    //         this.eventAssignmentsByDay[key].otHours,
    //         this.eventAssignmentsByDay[key].ot2Hours,
    //         this.eventAssignmentsByDay[key].mbp,
    //         this.eventAssignmentsByDay[key].tips
    //       ]);
    //     }
    //   }
    //   this.$gapi.getGapiClient().then(gapi => {
    //     const exportService = new ExportService(exportHeaders, Object.values(exportItems), gapi);
    //     exportService.export();
    //   });
    //   setTimeout(() => {
    //     this.performingRequest = false
    //   }, 2000)
    // },
    // exportRegister() {
    //   this.performingRequest = true
    //   const exportHeaders = [
    //     "Date",
    //     "First Name",
    //     "Last Name",
    //     "Position",
    //     "Hourly Rate",
    //     "Clock-In",
    //     "Clock-Out",
    //     "Total Hours",
    //     "Break",
    //     "Reg Hours",
    //     "Billable Hours",
    //     "Overtime",
    //     "2x Overtime",
    //     "Break Penalty",
    //     "CC Tips"
    //   ];
    //   const exportItems = [];
    //   for (var key in this.eventAssignments) {
    //     if (!this.eventAssignments[key].hidden) {


    //       let billHours
    //       if (this.eventAssignments[key].minHours > this.eventAssignments[key].regHours) {
    //         billHours = this.eventAssignments[key].minHours
    //       } else {
    //         billHours = this.eventAssignments[key].regHours
    //       } 

    //       // let inTime = (this.formatDate(this.eventAssignments[key].checkInTimeStamp) || this.eventAssignments[key].inTime)
    //       // let outTime = (this.formatDate(this.eventAssignments[key].checkOutTimeStamp) || this.eventAssignments[key].outTime)

    //       exportItems.push([
    //         this.eventAssignments[key].date,
    //         this.eventAssignments[key].firstName,
    //         this.eventAssignments[key].lastName,
    //         this.eventAssignments[key].position,
    //         this.eventAssignments[key].regRate,
    //         this.eventAssignments[key].inTime,
    //         this.eventAssignments[key].outTime,
    //         this.eventAssignments[key].totalHours,
    //         this.eventAssignments[key].breakTime,
    //         this.eventAssignments[key].regHours,
    //         billHours,
    //         this.eventAssignments[key].otHours,
    //         this.eventAssignments[key].ot2Hours,
    //         this.eventAssignments[key].mbp,
    //         this.eventAssignments[key].tips
    //       ]);
    //     }
    //   }
    //   this.$gapi.getGapiClient().then(gapi => {
    //     const exportService = new ExportService(exportHeaders, Object.values(exportItems), gapi);
    //     exportService.export();
    //   });
    //   setTimeout(() => {
    //     this.performingRequest = false
    //   }, 2000)
    // },
  },
  beforeDestroy () {
    this.$store.dispatch('clearEventUsersAndRef')
    this.$store.dispatch("clearEventAssignmentsByDay")
    this.$store.dispatch("clearEventAssignments")
    this.performingRequest = null
    delete this.performingRequest
    this.isVisible = null
    delete this.isVisible
    this.isHidden = null
    delete this.isHidden
    this.isVisibleByDay = null
    delete this.isVisibleByDay
    this.isHiddenByDay = null
    delete this.isHiddenByDay
    this.isPaid = null
    delete this.isPaid
    this.isPaidByDay = null
    delete this.isPaidByDay
    this.activeItem = null
    delete this.activeItem
    this.activeDay = null
    delete this.activeDay
    delete this.setStartDay
    delete this.updateDay
    delete this.showHidden
    delete this.showVisible
    delete this.showPaid
    delete this.showHiddenByDay
    delete this.showVisibleByDay
    delete this.showPaidByDay
    // delete this.formatDate
    delete this.exportRegisterByDay
    delete this.exportRegister
    delete this.visibleAssignmentsByDay
    delete this.hiddenAssignmentsByDay
    delete this.paidAssignmentsByDay
    this.newShiftDate = null
    delete this.newShiftDate
    this.shiftDates = null
    delete this.shiftDates
    this.isShowAddRows = null
    delete this.isShowAddRows
    this.isShowDateFilter = null
    delete this.isShowDateFilter
    this.isShowShiftFilter = null
    delete this.isShowShiftFilter
    this.isShowUserFilter = null
    delete this.isShowUserFilter
    this.endDate = null
    delete this.endDate
    this.startDate = null
    delete this.startDate
    this.filteredShift = null
    delete this.filteredShift
    this.filteredUser = null
    delete this.filteredUser
    
  }
}
</script>